import script from "./SettingsPositionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPositionsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPositionsSection.vue?vue&type=style&index=0&id=15d963bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d963bc"]])

export default __exports__